<template>
  <div class="consult_wrap">
    <div class="consult_btn">
      <div class="consult_item" v-for="(item, index) in consultList" :key="index"
        :class="activeIndex === index ? 'active' : ''" @click="changeIndex(index)">
        {{ item.tit }}
      </div>
    </div>
    <div class="consult_content">
      <div class="content_right">
        <img :src="consultImg" alt="" />
        <!-- <div class="left_btn hidden-sm-and-up" @click="gotoDemo">获取产品演示</div> -->
      </div>
      <div class="content_left">
        <div class="left_tit">{{ consultTitle }}</div>
        <div class="left_icon_wrap">
          <div class="icon_item" v-for="(item, index) in consultImgList" :key="index" ref="iconItem">
            <i :class="item.src" class="iconfont"></i>
            <span>{{ item.txt }}</span>
          </div>
        </div>
        <!-- <div class="left_btn hidden-xs-only" @click="gotoDemo">获取产品演示</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: 0,
      consultTitle: '',
      consultImgList: [
      ],
      consultImg: ''
    }
  },
  props: {
    consultList: {
      type: Array,
      default: [],
    },
    detailsArr: {
      type: Array,
      default: [],
    },
  },
  methods: {
    changeIndex(index) {
      this.activeIndex = index
      this.consultTitle = this.detailsArr[index].Title
      this.consultImgList = this.detailsArr[index].SubTitle.reduce((pre, cur) => {
        pre.push({
          src: 'icon-lingxing',
          txt: cur
        })
        return pre
      }, [])
      this.consultImg = this.detailsArr[index].Image
    },
    gotoDemo() {
      this.$router.push('/demo')
    }
  },
  mounted(){
  }
}
</script>

<style lang="scss" scoped>
.consult_wrap {
  width: 70%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.02) inset;

  @media screen and (max-width: 768px) {
    width: 95%;
    background: #f7f7f7;
  }

  .consult_btn {
    width: 100%;
    display: flex;

    .consult_item {
      flex: 1;
      height: 80px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      position: relative;
      cursor: pointer;

      @media screen and (max-width: 768px) {
        height: 60px;
        text-align: center;
        font-size: 14px;
      }
    }

    .active {
      color: #fff;
      background: #2091d3;
      font-weight: bold;

      &::before {
        content: '▲';
        position: absolute;
        color: #2091d3;
        font-size: 40px;
        transform: rotateX(180deg);
        bottom: -27px;
      }
    }
  }

  .consult_content {
    width: 100%;
    display: flex;
    padding: 30px;
    justify-content: center;

    @media screen and (max-width: 768px) {
      flex-direction: column;
    }

    .content_left {
      width: 40%;

      @media screen and (max-width: 768px) {
        width: 100%;
      }

      .left_tit {
        color: #2d3937;
        font-size: 17px;
        min-height: 90px;
        line-height: 20PX;

        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          padding: 10px 20px;
          color: #646464;
        }
      }

      .left_icon_wrap {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 30px;

        @media screen and (max-width: 768px) {
          justify-content: center;
        }

        .icon_item {
          width: 45%;
          height: 50px;

          &:nth-child(n+3) {
            margin-top: 10px;
          }

          @media screen and (max-width: 768px) {
            height: 50px;
          }

          i {
            color: #FDBA5D;
            font-size: 16PX;
            padding-right: 10px;
          }

          span {
            color: #646464;
            font-size: 14PX;
          }
        }
      }

      .left_btn {
        width: 150PX;
        height: 40PX;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
      }
    }

    .content_right {
      width: 40%;
      margin-right: 100px;

      @media screen and (max-width: 768px) {
        width: 100%;
        text-align: center;
      }

      text-align: right;

      img {
        margin-top: 30px;
        width: 80%;
      }

      .left_btn {
        width: 180px;
        height: 50px;
        background: orange;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;

        @media screen and (max-width: 768px) {
          width: 120px;
          height: 35px;
          font-size: 14px;
          border-radius: 20px;
          margin: 20px auto;
        }
      }
    }
  }
}
</style>